export {Table} from 'antd';
export type {TableProps} from 'antd/es/table/index';